<script>
import * as Lib from "@/lib/functions/plain";
import { Level, Event } from "@/lib/definition/constants";

//mport moment from "moment";
import moment from "moment-timezone";
import _ from "lodash";
import Param from "@/lib/definition/variables";

export default {
  async mounted() {
    var to = this.$route;
    this.createPageTitle(to);
    if (!this.$store.getters["Login/loggedIn"]){
      this.$router.push(this.site.deployFolder + "/loginview")
    } else {
      await this.$store.dispatch('Login/getUserInfo')
      await this.$store.dispatch("Masters/getMastersIfNeeded");
      this.masterReady()
    }
  },
  components: {
  },
  computed: {
    timezone() { return this.$store.state.Timesheet.timezone; },
    offsetMin() { return this.$store.state.Timesheet.offsetMin; },
    utctime() { return this.$store.state.Timesheet.utctime; }
  },
  filters: {
    momentMonth: function(date) {
      return moment(date).format("YYYY-MM");
    },
    momentDate: function(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    momentDateStd: function(date) {
      if (date == null) return "";
      return moment(date).format("YYYY/MM/DD");
    },
    momentDateTime: function(date) {
      return moment(date).format("YYYY/MM/DD HH:mm");
    },
    momentDateTimeSecond: function(date) {
      return moment(date).format("YYYY/MM/DD HH:mm:ss");
    },
    toLocaleStr: function(v) {
      if (v == null) {
        return "";
      }
      return v.toLocaleString();
    }
  },
  data() {
    return {
      site: Param.Site
    };
  },
  methods: {
    // ページタイトル生成
    createPageTitle: function(to) {
      if (to.name) {
        var setTitle = to.name + "｜Koos";
        document.title = setTitle;
      } else {
        document.title = "Koos";
      }
    },
    // コンポーネントタグ(テンプレートで定義された文字列)を返します。文字列はアッパーキャメルケースで統一して返されます。
    componentTag() {
      let tag = this.$options._componentTag;
      return tag ? _.upperFirst(_.camelCase(tag)) : null;
    },
    async masterReady() {

    },
    dispError(message) {
    this.$store.direct.dispatch.App.dispError(message);
    },
    dispSuccess(message) {
      this.$store.direct.dispatch.App.dispSuccess(message);
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      this.createPageTitle(to);
    }
  }
};
</script>